export function crmWidget() {
    return {
      restrict: 'E',
      template: require('./widget.directive.html'),
      scope: {
            company: '<',
            organizationId: '<',
            configuration: '='
      },
      controller: controller,
    };
  }
  
  controller.$inject = ['$scope'];
  function controller($scope) {
    
    init();
    
    $scope.widgetUnits = [
      {
        'id': '%',
        'label': '%'
      }, 
      {
        'id': 'px',
        'label': 'px'
      }
    ]

    function initWidgetValues() {
      const currentStringWidth = $scope.configuration.widget.width;
      const currentStringHeight = $scope.configuration.widget.height;
      $scope.configuration.widget = {
        width: {
          value: currentStringWidth ? Number(currentStringWidth.value) : 0,
          unit: $scope.configuration.widget.width.unit
        },
        height: {
          value: currentStringHeight ? Number(currentStringHeight.value) : 0,
          unit: $scope.configuration.widget.height.unit
        }
      }
    }

    function init() {
      initWidgetValues();
    }
}